<template>
<TsCard  :appendClass="twMerge('lg:p-4 pl-0 max-md:rounded-md bg-white shadow-none border-[#DEEFFF]',props.appendClass)">

  <TsMedia appendClass="items-center">
    <TsMediaStart>
      <div class="flex">
      <TsCheckbox v-if="!isMobile"
    @click.stop="stopClick"
    :checked="isSelected"
    @change="toggleMessageSelection"
/>
      <TsImage v-if="props.image" width="60" height="60" :src="props.image" alt="toolstation" loading="lazy" />
      </div>
    </TsMediaStart>
    <TsMediaContent>
      <div class="flex max-md:flex max-md:justify-between">
        <TsTypography variant="h4" :weight="props.variant  ? 'medium' : 'bold'" :appendClass="twMerge('text-idle-black mb-0 pr-3 ',props.variant && 'pr-3 mb-0  text-natural-grey')">Toolstation</TsTypography>
        <TsTypography :weight="props.variant ?'medium':'bold'" v-if="props.messageTime" variant="h5" :appendClass="props.variant?'text-natural-silver-grey lg:border-l pl-3 mb-0':'lg:border-l text-natural-grey pl-3 mb-0'">{{props.messageTime}}</TsTypography>

      </div>
      <TsTypography v-if="props.description" appendClass="text-natural-grey mt-2 mb-0 line-clamp-1 " variant="h4" :weight="props.variant ?'medium':'bold'" >{{props.description}} <span @click="viewDetail = true" v-if="props.hyperLinkText" class="cursor-pointer text-blue-500 underline">{{props.hyperLinkText}}</span></TsTypography>
    </TsMediaContent>
  </TsMedia>
</TsCard>

  <ClientOnly>
  <Teleport to="body">
    <TsModal appendClass="border-2 p-6 max-w-xl max-h-60" v-model:visible="viewDetail">
      <template #modal-content="{modal}">
        <TsMedia appendClass=" mb-3">
          <TsMediaStart>
            <TsImage class="" v-if="props.image" width="60" height="60" :src="props.image" alt="toolstation" loading="lazy"/>
          </TsMediaStart>
          <TsMediaEnd>
            <TsIcon @click="modal?.hide()" class="cursor-pointer rounded-md hover:bg-gray-200" name="bitcoin-icons:cross-outline"  />
          </TsMediaEnd>
        </TsMedia>
            <div class="flex max-md:flex max-md:justify-between ">
              <TsTypography variant="h4" weight="bold" :appendClass="twMerge('text-idle-black mb-0 pr-3 ',props.variant===false&& 'pr-3 mb-0  text-natural-grey')">Toolstation</TsTypography>
              <TsTypography weight="semibold" v-if="props.messageTime" variant="h5" appendClass="lg:border-l text-natural-grey pl-3 mb-0">{{props.messageTime}}</TsTypography>
            </div>
            <TsTypography v-if="props.description" appendClass="text-natural-grey mt-4 mb-0 " variant="h4" :weight="props.variant ?'medium':'bold'">{{props.description}}</TsTypography>

      </template>
    </TsModal>
  </Teleport>
  </ClientOnly>
</template>


<script setup lang="ts">
import {twMerge} from "tailwind-merge";
import {ref} from 'vue';

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
);

const TsMediaEnd = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaEnd.vue')
);

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
);

const {isMobile} = useDevice();
const viewDetail=ref(false);
type Props = {
  appendClass?:string;
  variant?:boolean;
  description?:string;
  hyperLinkText?:string;
  messageTime?:string;
  image?:string;
  isSelected?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  description:'',
  hyperLinkText:'',
  messageTime:'',
  image:'/images/messageTS.png',
  isSelected: false
});

const stopClick = (event: Event) => {
  event.stopPropagation();
};
const emit = defineEmits(['select']);

const toggleMessageSelection = () => {
  emit('select');
};

</script>